module.exports = __webpack_public_path__ + "static/media/sigWave.8cb0d687.svg";